'use client';

import React from 'react';
import styled from 'styled-components';

interface CertificateCardProps {
  icon: React.ReactNode;
  iconColor: string;
  label: string;
  value: string;
  status: string;
  statusColor: string;
  className?: string;
}

const Card = styled.div`
  background-color: #f5f5f5;
  border: none;
  border-radius: 0px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconContainer = styled.div<{ $color: string }>`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${props => props.$color}20;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 28px;
    height: 28px;
    color: ${props => props.$color};
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
`;

const Value = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
`;

const Status = styled.div<{ $color: string }>`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.$color};
`;

export const CertificateCard: React.FC<CertificateCardProps> = ({
  icon,
  iconColor,
  label,
  value,
  status,
  statusColor,
  className,
}) => {
  return (
    <Card className={className}>
      <IconContainer $color={iconColor}>
        {icon}
      </IconContainer>
      <Content>
        <Label>{label}</Label>
        <Value>{value}</Value>
        <Status $color={statusColor}>{status}</Status>
      </Content>
    </Card>
  );
};

